import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { computed } from "@vue/composition-api";
export const useIncomeHistoryFieldBindings = options => {
  const {
    bindAddressField,
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIncomePath = computed(() => {
    return currentApplicantPath.value + "[employment]" + `[${options.employmentIndex.value}]`;
  });
  const employerName = bindApplication(makeFieldPathReactive(currentIncomePath, "[employer-name]"), "");
  const currentJob = bindApplication(makeFieldPathReactive(currentIncomePath, "[current-job]"), null);
  const companyType = bindApplication(makeFieldPathReactive(currentIncomePath, "[company-type]"), "");
  const employmentType = bindApplication(makeFieldPathReactive(currentIncomePath, "[employment-type]"), "");
  const grossRevenue = bindApplication(makeFieldPathReactive(currentIncomePath, "[gross-revenue]"), 0);
  const incomeAmount = bindApplication(makeFieldPathReactive(currentIncomePath, "[income-amount]"), 0);
  const incomePeriod = bindApplication(makeFieldPathReactive(currentIncomePath, "[income-period]"), "");
  const incomeType = bindApplication(makeFieldPathReactive(currentIncomePath, "[income-type]"), "");
  const industrySector = bindApplication(makeFieldPathReactive(currentIncomePath, "[industry-sector]"), "");
  const jobTitle = bindApplication(makeFieldPathReactive(currentIncomePath, "[job-title]"), "");
  const monthsInIndustry = bindApplication(makeFieldPathReactive(currentIncomePath, "[months-in-industry]"), 0);
  const occupation = bindApplication(makeFieldPathReactive(currentIncomePath, "[occupation]"), "");
  const operatingAs = bindApplication(makeFieldPathReactive(currentIncomePath, "[operating-as]"), "");
  const selfEmployed = bindApplication(makeFieldPathReactive(currentIncomePath, "[self-employed]"), null);
  const timeAtJob = bindApplication(makeFieldPathReactive(currentIncomePath, "[time-at-job]"), 0);
  const employmentWorkPhone = bindApplication(makeFieldPathReactive(currentIncomePath, "[work-phone]"), "");
  const employmentAddress = bindAddressField(makeFieldPathReactive(currentIncomePath, "[address]"));
  return {
    employerName,
    currentJob,
    companyType,
    employmentType,
    grossRevenue,
    incomeAmount,
    incomePeriod,
    incomeType,
    industrySector,
    jobTitle,
    monthsInIndustry,
    occupation,
    operatingAs,
    selfEmployed,
    timeAtJob,
    employmentWorkPhone,
    employmentAddress
  };
};